module.exports = __webpack_public_path__ + "img/Icon - Locked-Dull.6046764e.svg";